import { useFormik } from 'formik';
import { initialValues } from './formData';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../services/param.service';
import {
    FinalCausality,
    FinalCausalityFilter,
} from '../../../../../shared/types/typifications/finalCausality';
import { cleanObj } from '../../../../../shared/utils/objects';

export const useFinalCausalityFilters = (
    onFilter?: (data: FinalCausalityFilter) => void
) => {
    const [causalities, setCausalities] = useState<ISelect[]>([]);

    const onSubmit = (data: FinalCausality) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_FINAL_CAUSALITY).then((items) =>
            setCausalities(items)
        );
    }, []);

    return {
        formik,
        causalities,
    };
};
